/*Generated from the `:::quiz{key="06273c1d-a469-408f-9ed6-a6c5a152651e" slug="level-1/after-𠃌/quiz-not-a-stroke"}` directive (simplified/001/017/𠃌.mdx). Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {Quiz, QuizOption, ...html} = components;
  if (!Quiz) _missingMdxReference("Quiz", true);
  if (!QuizOption) _missingMdxReference("QuizOption", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(html.p, {
      children: ["Which one of these is ", _jsx(html.strong, {
        children: "not",
        components: html
      }), " a stroke?"]
    }), _jsxs(Quiz, {
      select: "one",
      children: [_jsx(QuizOption, {
        glyph: "丨",
        components: html
      }), _jsx(QuizOption, {
        glyph: "𠃊",
        components: html
      }), _jsx(QuizOption, {
        glyph: "十",
        correct: true,
        components: html
      }), _jsx(QuizOption, {
        glyph: "丿",
        components: html
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
